// extracted by mini-css-extract-plugin
export var layoutContainer = "_ai-0";
export var layoutContainerNoRounding = "_ai-6";
export var layoutContainerOpen = "_ai-5";
export var layoutContainerResizing = "_ai-1";
export var mainContent = "_ai-2";
export var resizeDivider = "_ai-3";
export var slidePanel = "_ai-4";